<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد وضعیت سرویس ها  </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 gy-3 px-4 w-100  py-3">

    <!-- وضعیت سرویس های امروز -->

    <div class="col-12 p-1">

        <div class="col-12 border border-2 rounded">

            <p class="text-center f18 bg-success p-2  text-white"> وضعیت سرویس های امروز </p>

            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

        </div> 

    </div>

    <!-- لیست سرویس های انجام شده -->

    <div class="col-12 p-1 border border-2 rounded">

        <p [ngStyle]="{'background-color': '#ACE1AF'}" class="text-center f18 p-2"> لیست سرویس های انجام شده </p>

        <table class="table table-striped table-responsive rounded-3 " id="export-excel">

            <thead>

                <tr class="">

                    <th class="text-center"> # </th>

                    <th class="text-center"> مسیر  </th>

                    <th class="text-center"> ساعت شروع </th>

                    <th class="text-center"> خودرو  </th>
                    
                    <th class="text-center"> وضعیت  </th>

                </tr>

            </thead>

            <tbody>

                <tr [ngStyle]="{'background-color': '#ACE1AF'}" *ngFor="let item of lst_Status1; let i=index">

                    <td class="text-center"> {{ i + 1 | faNum }} </td>
                    
                    <td class="text-center"> {{ item.strName }} </td>

                    <td class="text-center"> {{ item.strSTime | faNum }} </td>

                    <td class="text-center"> {{ item.strFullName }} </td>

                    <td class="text-center"> {{ item.strStatus | faNum }} </td>

                    <td class="text-center"> {{ item.strFullName }} </td>

                </tr>

            </tbody>

        </table>

    </div>
    
    <!-- لیست سرویس های باقیمانده -->

    <div class="col-12 p-1 border border-2 rounded">

        <p [ngStyle]="{'background-color': '#E9D66B'}" class="text-center f18 p-2"> لیست سرویس های باقیمانده </p>

        <table class="table table-striped table-responsive rounded-3 " id="export-excel">

            <thead>

                <tr class="">

                    <th class="text-center"> # </th>

                    <th class="text-center"> مسیر  </th>

                    <th class="text-center"> ساعت شروع </th>

                    <th class="text-center"> خودرو  </th>
                    
                    <th class="text-center"> وضعیت  </th>

                </tr>

            </thead>

            <tbody>

                <tr [ngStyle]="{'background-color': '#E9D66B'}" *ngFor="let item of lst_Status2; let i=index">

                    <td class="text-center"> {{ i + 1 | faNum }} </td>
                    
                    <td class="text-center"> {{ item.strName }} </td>

                    <td class="text-center"> {{ item.strSTime | faNum }} </td>

                    <td class="text-center"> {{ item.strFullName }} </td>

                    <td class="text-center"> {{ item.strStatus | faNum }} </td>

                </tr>

            </tbody>

        </table>

    </div>

    <!-- لیست سرویس های انجام نشده -->

    <div class="col-12 p-1 border border-2 rounded">

        <p [ngStyle]="{'background-color': '#F88379'}" class="text-center f18 p-2"> لیست سرویس های انجام نشده </p>

        <table class="table table-striped table-responsive rounded-3 " id="export-excel">

            <thead>

                <tr class="">

                    <th class="text-center"> # </th>

                    <th class="text-center"> مسیر  </th>

                    <th class="text-center"> ساعت شروع </th>

                    <th class="text-center"> خودرو  </th>
                    
                    <th class="text-center"> وضعیت  </th>

                </tr>

            </thead>

            <tbody>

                <tr [ngStyle]="{'background-color': '#F88379'}" *ngFor="let item of lst_Status3; let i=index">

                    <td class="text-center"> {{ i + 1 | faNum }} </td>
                    
                    <td class="text-center"> {{ item.strName }} </td>

                    <td class="text-center"> {{ item.strSTime | faNum }} </td>

                    <td class="text-center"> {{ item.strFullName }} </td>

                    <td class="text-center"> {{ item.strStatus | faNum }} </td>

                </tr>

            </tbody>

        </table>

    </div>
    
    <!-- لیست پرسنل استفاده کننده از سرویس امروز -->

    <div class="col-12 p-1 border border-2 rounded">

        <p class="text-center bg-success text-white f18 p-2"> لیست پرسنل استفاده کننده از سرویس امروز </p>

        <table class="table table-striped table-responsive rounded-3 " id="export-excel">

            <thead>

                <tr class="">

                    <th class="text-center"> # </th>

                    <th class="text-center"> نام و نام خانوادگی </th>

                    <th class="text-center"> زمان سوار شده </th>

                </tr>

            </thead>

            <tbody>

                <tr *ngFor="let item of lst_Current_Passenger; let i=index">

                    <td class="text-center"> {{ i + 1 | faNum }} </td>
                    
                    <td class="text-center"> {{ item.strName + ' ' + item.strFamily }} </td>

                    <td class="text-center"> {{ item.strTime | faNum }} </td>

                </tr>

            </tbody>

        </table>

    </div>

    <!-- پرسنل سوار شده -->

    <div class="col-12 p-1 border border-2 rounded">

        <div class="d-flex justify-content-center flex-wrap">

            <div class="col-12 mt-3">

                <p class="text-center bg-success text-white f18 p-2"> پرسنل سوار شده </p>

            </div>

            <div class=" col-12 mb-5 p-2 mt-2">
    
                <div id="test" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>